import { ItemJsEnv } from './item_js_env';
import { ExtendsModal } from '../actions/item_movie_action';

export class ItemExpansionModal {
  static itemExpansionModalCaseItemMovie(model: ItemJsEnv){
    return new ExtendsModal(model);
  }
}
